<template>
  <div
    class="modal fade"
    id="modal-block-add-supplier"
    tabindex="-1"
    role="dialog"
    aria-labelledby="modal-block-add-supplier"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-block-add-supplier modal-lg" role="document">
      <div class="modal-content">
        <div class="block block-themed block-transparent mb-0">
          <div class="block-header bg-primary-dark">
            <h3 class="block-title">Add Supplier</h3>
            <div class="block-options">
              <button
                type="button"
                class="btn-block-option"
                data-dismiss="modal"
                aria-label="Close"
              >
                <i class="fa fa-fw fa-times"></i>
              </button>
            </div>
          </div>
          <div class="block-content">
            <div class="block block-rounded block-bordered">
              <ul
                class="nav nav-tabs nav-tabs-alt js-tabs-enabled supplierTab"
                data-toggle="tabs"
                role="tablist"
              >
                <li class="nav-item">
                  <span
                    :class="type == 1 ? 'nav-link active' : 'nav-link'"
                    v-on:click="changeTab(1)"
                    >Consumer</span
                  >
                </li>
                <li class="nav-item">
                  <span
                    :class="type == 2 ? 'nav-link active' : 'nav-link'"
                    v-on:click="changeTab(2)"
                    >Business</span
                  >
                </li>
              </ul>
              <div class="block-content tab-content">
                <div
                  class="tab-pane active"
                  id="customerSupplier"
                  role="tabpanel"
                >
                  <span v-if="suppliersFiltered.length === 0">
                    This Type hasn't data.</span
                  >
                  <div
                    id="accordion"
                    role="tablist"
                    aria-multiselectable="true"
                  >
                    <div
                      class="block block-rounded mb-1"
                      v-for="(item, key) in suppliersFiltered"
                      v-if="item.propositions.length > 0"
                      :key="item.id"
                    >
                      <div
                        class="block-header block-header-default"
                        role="tab"
                        :id="'accordion_h' + key"
                      >
                        <a
                          class="font-w600"
                          data-toggle="collapse"
                          data-parent="#accordion"
                          :href="'#accordion_q' + key"
                          aria-expanded="true"
                          v-on:click="category_field = 0"
                          >{{ item.name }}</a
                        >
                      </div>
                      <div
                        :id="'accordion_q' + key"
                        class="collapse"
                        role="tabpanel"
                        data-parent="#accordion"
                      >
                        <div class="block-content">
                          <div
                            v-if="
                              item.product_id === 4 || item.product_id === 8
                            "
                          >
                            <ul
                              class="nav nav-tabs nav-tabs-alt js-tabs-enabled supplierTab"
                              data-toggle="tabs"
                              role="tablist"
                            >
                              <li
                                class="nav-item"
                                v-for="(group, key, key2) in groupBy(
                                  item.propositions,
                                  'category_field'
                                )"
                                :key="group.id"
                              >
                                <span
                                  :class="
                                    category_field === key2 ||
                                    category_field === key
                                      ? 'nav-link active'
                                      : 'nav-link'
                                  "
                                  v-on:click="category_field = key2"
                                  >{{
                                    group[0].category_name
                                      ? group[0].category_name[lang]
                                      : "Package"
                                  }}</span
                                >
                              </li>
                            </ul>
                            <div class="block-content tab-content">
                              <div
                                class="tab-pane"
                                :class="
                                  category_field === key2 ||
                                  category_field === key
                                    ? 'active'
                                    : ''
                                "
                                v-for="(group, key, key2) in groupBy(
                                  item.propositions,
                                  'category_field'
                                )"
                                :key="group.id"
                                :id="group[0].category_field"
                                role="tabpanel"
                              >
                                <div class="row no">
                                  <div
                                    class="col-md-3 mb-3"
                                    v-for="prop in group"
                                    v-if="
                                      findItem(
                                        item.product_id,
                                        prop.proposition_id
                                      )
                                    "
                                    :key="prop.id"
                                  >
                                    <div class="utility">
                                      <div for="product-8">
                                        <button
                                          class="btn btn-success float-right m-1"
                                          style="right: 0; position: absolute"
                                          @click="
                                            addSupplier(
                                              item.id,
                                              prop.proposition_id,
                                              item.type
                                            )
                                          "
                                        >
                                          <i class="fas fa-plus"></i>
                                        </button>
                                        <img
                                          v-if="item.logo"
                                          :src="getImage(item.logo)"
                                        />
                                        <span>{{
                                          parseJSONSupplierName(prop.name, lang)
                                        }}</span>
                                        <a style="z-index: 110" class="more"
                                          >More info</a
                                        >
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div v-else class="row">
                            <div
                              class="col-md-3 mb-3"
                              v-for="prop in item.propositions"
                              v-if="
                                from === 'formManager'
                                  ? true
                                  : findItem(
                                      item.product_id,
                                      prop.proposition_id
                                    )
                              "
                              :key="prop.id"
                            >
                              <div class="utility">
                                <div for="product-8">
                                  <button
                                    class="btn btn-success float-right m-1"
                                    style="right: 0; position: absolute"
                                    @click="
                                      addSupplier(
                                        item.id,
                                        prop.proposition_id,
                                        item.type
                                      )
                                    "
                                  >
                                    <i class="fas fa-plus"></i>
                                  </button>
                                  <img
                                    v-if="item.logo"
                                    :src="getImage(item.logo)"
                                  />
                                  <span>{{
                                    parseJSONSupplierName(prop.name, lang)
                                  }}</span>
                                  <a style="z-index: 110" class="more"
                                    >More info</a
                                  >
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "supplierAddModal",
  data() {
    return {
      type: 1,
      category_field: 0,
      suppliersFiltered: []
    };
  },
  props: ["product", "from"],
  computed: {
    ...mapState({
      productSupplierAll: state => state.suppliers.supplier,
      suppliersIndex: state => state.suppliers.index
    })
  },
  methods: {
    addSupplier: function(id, proposition_id, type) {
      let supplier = this.productSupplierAll.find(
        x => x.id === id && x.type === type
      );
      let propositons = supplier.propositions.filter(
        x => x.proposition_id === proposition_id
      )[0];
      let supplierItem = this.form.data.fields[this.suppliersIndex].filter(
        x => x.product === supplier.product_id && x.type === "suppliers"
      )[0];

      /* Supplier->Proposition */
      let pushItem = {
        id: propositons.proposition_id,
        disabled: 0,
        available: 0,
        default: null,
        show:
          supplierItem.group === "mobile" ||
          supplierItem.group === "internet" ||
          supplierItem.group === "bankaccount"
            ? supplierItem.groupDefault == id
              ? 1
              : 0
            : 1,
        status: 0,
        title: supplier.name,
        logo: supplier.logo,
        supplier_type: supplier.type,
        supplier_id: supplier.id,
        knowledge_base: supplier.knowledge_base,
        description: supplier.description,
        name: propositons.name,
        filters: propositons.filters,
        rate_period:
          propositons.rate_period_id === 8 ? 1 : propositons.rate_period_id,
        category_field: propositons.category_field,
        category_name: propositons.category_name,
        proposition_type: propositons.type,
        product_id: supplier.product_id,
        render_type: propositons.render_type
      };
      supplierItem.animate = 1;
      supplierItem.suppliers.push(pushItem);
    },
    findItem(product_id, id) {
      let supplierwidget = [];
      if (
        this.form.data.fields[this.suppliersIndex] &&
        Array.isArray(this.form.data.fields[this.suppliersIndex])
      ) {
        supplierwidget = this.form.data.fields[this.suppliersIndex].filter(
          y => y.product === product_id && y.type === "suppliers"
        );
      }
      if (supplierwidget.length > 0) {
        return !supplierwidget[0].suppliers.find(item => item.id === id);
      }
    },
    changeTab(type) {
      this.type = type;

      if (this.productSupplierAll.filter(x => x.type === type)) {
        this.suppliersFiltered = this.productSupplierAll.filter(
          x => x.type === type
        );
      } else {
        this.suppliersFiltered = [];
      }
    },
    parseJSONSupplierName(text, language) {
      try {
        return JSON.parse(text)[language];
      } catch (e) {
        return text;
      }
    }
  },
  watch: {
    productSupplierAll() {
      this.category_field = 0;
      this.suppliersFiltered = this.productSupplierAll.filter(
        x => x.type === 1
      );
    }
  }
};
</script>

<style scoped>
.utility img {
  max-width: 40px;
  display: block;
  margin: 0 auto;
  margin-top: 25px;
}

.utility input {
  display: none;
}

.utility div {
  display: block;
  position: relative;
  border: 1px solid #a0a0a0;
  text-align: center;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  height: 160px;
  cursor: pointer;
  transition: background-color 0.2s, box-shadow 0.2s;
}

.utility .more {
  width: 100%;
  background: #f5fbfd;
  display: block;
  text-align: center;
  color: #1678aa;
  padding: 10px;
  position: absolute;
  bottom: 0;
  left: 0;
  font-weight: normal;
  font-size: 14px;
}

.supplierTab span {
  cursor: pointer;
}
</style>
